var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import { Expose } from 'class-transformer';
import { EFileExtension, EFileType } from '~/shared/types';
export class ModelBookContentDocument {
    cdate;
    communityId;
    description;
    eventId;
    fileExtension;
    folderId;
    hasWaterMark;
    hash;
    id;
    isCleanup;
    isConverted;
    mdate;
    name;
    objType;
    origExtension;
    originId;
    path;
    resolution;
    state;
    subType;
    syncAllowChange;
    syncId;
    time;
    userId;
    weight;
    order;
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "cdate", void 0);
__decorate([
    Expose({ name: 'community_id' }),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "communityId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookContentDocument.prototype, "description", void 0);
__decorate([
    Expose({ name: 'event_id' }),
    __metadata("design:type", Object)
], ModelBookContentDocument.prototype, "eventId", void 0);
__decorate([
    Expose({ name: 'file_extension' }),
    __metadata("design:type", typeof (_a = typeof EFileExtension !== "undefined" && EFileExtension) === "function" ? _a : Object)
], ModelBookContentDocument.prototype, "fileExtension", void 0);
__decorate([
    Expose({ name: 'folder_id' }),
    __metadata("design:type", String)
], ModelBookContentDocument.prototype, "folderId", void 0);
__decorate([
    Expose({ name: 'has_watermark' }),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "hasWaterMark", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookContentDocument.prototype, "hash", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "isCleanup", void 0);
__decorate([
    Expose({ name: 'is_converted' }),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "isConverted", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "mdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentDocument.prototype, "name", void 0);
__decorate([
    Expose({ name: 'obj_type' }),
    __metadata("design:type", typeof (_b = typeof EFileType !== "undefined" && EFileType) === "function" ? _b : Object)
], ModelBookContentDocument.prototype, "objType", void 0);
__decorate([
    Expose({ name: 'orig_extension' }),
    __metadata("design:type", typeof (_c = typeof EFileExtension !== "undefined" && EFileExtension) === "function" ? _c : Object)
], ModelBookContentDocument.prototype, "origExtension", void 0);
__decorate([
    Expose({ name: 'original_id' }),
    __metadata("design:type", Object)
], ModelBookContentDocument.prototype, "originId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentDocument.prototype, "path", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookContentDocument.prototype, "resolution", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBookContentDocument.prototype, "state", void 0);
__decorate([
    Expose({ name: 'sub_type' }),
    __metadata("design:type", typeof (_d = typeof EFileType !== "undefined" && EFileType) === "function" ? _d : Object)
], ModelBookContentDocument.prototype, "subType", void 0);
__decorate([
    Expose({ name: 'sync_allow_change' }),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "syncAllowChange", void 0);
__decorate([
    Expose({ name: 'sync_id' }),
    __metadata("design:type", Object)
], ModelBookContentDocument.prototype, "syncId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBookContentDocument.prototype, "time", void 0);
__decorate([
    Expose({ name: 'user_id' }),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "userId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentDocument.prototype, "weight", void 0);
